module.exports = __webpack_public_path__ + "521e76fe5bd6d15ea233dd596e2eb69a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/mentor/Sunada2x.png
// module id = 105
// module chunks = 0